<script setup lang="ts">
/**
 * 应用外壳。
 *
 * 高度链条是**必须精确**的（原实现记录过一次实测事故）：
 * `body.flex.h-dvh.flex-col.overflow-hidden`（index.html 上）
 *   → `main.flex-1.min-h-0.overflow-y-auto`
 *     → `div.flex.min-h-full.shrink-0.flex-col`
 * 少任何一个 `min-h-0`，flex 子项就会按内容撑高而不再滚动，
 * 表现是"页面整体在滚，聊天输入框被推到屏幕外"。
 *
 * 页脚不在外壳里：聊天页把页脚渲染在**消息列表内部**（跟着消息一起滚），
 * 其它页面各自在底部渲染。放在外壳里会让聊天页出现两个页脚。
 *
 * 后台路由（`/admin/**`）**不渲染全局页头**：后台有自己的一套外壳
 * （`views/admin/AdminLayoutView.vue` 的顶栏 + 侧栏）。两套都渲染会出现
 * 上下两个堆叠的导航条，而这正是需求里"外观风格保持不变"最容易被破坏的地方。
 * 判据用 `route.path.startsWith('/admin')` 而不是路由 meta：外壳在 `<RouterView>`
 * **之外**，拿不到目标路由的 meta 时（例如首次解析中）会闪一下错误状态。
 */

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from './components/layout/AppHeader.vue';
import ApiEvents from './components/providers/ApiEvents.vue';
import ToastProvider from './components/ui/ToastProvider.vue';

const route = useRoute();
/** 后台自带外壳，不要再叠一层全局页头 */
const showAppHeader = computed(() => !route.path.startsWith('/admin'));
</script>

<template>
  <ToastProvider>
    <ApiEvents />
    <AppHeader v-if="showAppHeader" />
    <main class="flex min-h-0 flex-1 flex-col overflow-y-auto">
      <div class="flex min-h-full shrink-0 flex-col">
        <RouterView />
      </div>
    </main>
  </ToastProvider>
</template>
